import React from "react";
import { BadgeCheck, Circle } from "lucide-react";
import { Avatar as MuiAvatar, Box, Typography, Badge } from "@mui/material";
import StatusBadge from "../UiSettings/StatusBadge";
import { userSelector } from "../../../user-redux/selector";
import { useSelector } from "react-redux";
import Key from "../../../../clientVariables.json";

const Avatar = () => {
  const { user } = useSelector(userSelector);
  return (
    <Box sx={{ textAlign: "center", mt: 2 }}>
      {/* Avatar with status badges */}
      <Box sx={{ position: "relative", display: "inline-block" }}>
        <MuiAvatar
          key={user?._imageTs || user?.image}
          alt={user?.full_name || "User Avatar"}
          src={`${Key.aws_bucket_profile}/attachments/user_${user?.id}/profileimages/${user?.image}${user?._imageTs ? `?v=${user._imageTs}` : ""}`}
          sx={{
            width: 128,
            height: 128,
            border: "4px solid #fff",
            boxShadow: 3,
          }}
        />

        {/* Verification badge */}
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          badgeContent={
            <BadgeCheck
              size={20}
              style={{
                color: "#1e88e5",
                backgroundColor: "white",
                borderRadius: "50%",
              }}
            />
          }
          sx={{
            position: "absolute",
            top: 42,
            right: 2,
            zIndex: 1,
            bgcolor: "white",
            p: 0.5,
            borderRadius: "50%",
          }}
        />
      </Box>

      {/* User Details */}
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" fontWeight="bold" color="text.primary">
          {user.full_name || " N/A"}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 0.5 }}>
          <StatusBadge
            label={
              user.usertype == 3
                ? "Recruiter"
                : user.usertype == 6
                ? "Candidate"
                : user.usertype == 13
                ? "Admin"
                : user.usertype == 7
                ? "Company Admin"
                : null
            }
            color="blue"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Avatar;
